/**
 * Usage API client
 */

import apiClient from './client';

export interface FriendUsageStats {
  friend: {
    id: string;
    display_name: string;
    username: string | null;
  };
  total_bytes: number;
  bytes_uploaded: number;
  bytes_downloaded: number;
  total_sessions: number;
  total_duration_minutes: number;
  last_session_at: string | null;
}

export interface UsageSummaryResponse {
  total_bytes_shared: number;
  total_sessions_hosted: number;
  total_hosting_duration_minutes: number;
  unique_friends_count: number;
  friends: FriendUsageStats[];
  period_start: string | null;
  period_end: string | null;
}

/**
 * Get usage summary for the current user
 */
export const getUsageSummary = async (periodDays: number = 30) => {
  return apiClient.get<UsageSummaryResponse>(`/usage/summary?period_days=${periodDays}`);
};

export const usageApi = {
  getUsageSummary,
};
